import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import AgencyQuery from '../../models/agency-query.model';
import Agency from '../../models/agency.model';
import { PaginatedResult } from '../../models/paginated.model';
import ColisportApiResource from './colisport-api-resource.model';

export default class AgencyApi implements ColisportApiResource {
  readonly apiUrlPath = 'agency';

  constructor(readonly httpClient: AxiosInstance) {}

  getAgencies(agencyDetails: AgencyQuery): Promise<AxiosResponse<Agency[]>> {
    return this.httpClient.post(`${this.apiUrlPath}/available`, agencyDetails);
  }

  /**
   * Busca PAGINADA de agências (palco /colibike, scroll infinito no step de
   * contactos). GET agency/search com os mesmos filtros do /available
   * (offerType/postalCode/transporter/country/city) + page/limit. Devolve o
   * envelope PaginatedResult. AbortSignal (via useInfiniteResource) cancela
   * páginas obsoletas. NÃO mexe no POST /available (partilhado com a Colisport).
   */
  searchAgenciesPaginated(
    params: {
      offerType: string;
      postalCode: string;
      transporter: string;
      country: string;
      city: string;
      page: number;
      limit: number;
    },
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<PaginatedResult<Agency>>> {
    return this.httpClient.get(`${this.apiUrlPath}/search`, {
      ...(config ?? {}),
      params,
    });
  }
}
